module.exports = __webpack_public_path__ + "38f7d93f0d82e223a3990ec440226fb9.png";